// DEFAULT MESSAGES
const DEFAULT_ERROR_MESSAGE = `Infelizmente estamos com problemas em nosso serviço. ` +
                              `Certifique-se de que esteja conectado na internet e, ` +
                              `por favor, tente novamente mais tarde.`;

const DEFAULT_UNKNOWN_ERROR_MESSAGE = `Erro não documentado. Por favor, entre em contato com ` +
                                      `o suporte para que isto seja corrigido`;

export {DEFAULT_ERROR_MESSAGE, DEFAULT_UNKNOWN_ERROR_MESSAGE};

// COMPLAINT CASE
export const COMPLAINT_CASE_STATUS_OPTIONS = [
    'Preenchido e arquivado',
    'Arquivado',
    'Formulário preenchido',
    'Aguardando preenchimento'
];